import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useParams, Link } from 'react-router-dom';

import TaskListAccordion from '~components/tasklist/TaskListAccordion';
import { fetchOrder } from '~services/api.helpers';
import { useToast } from '~features/toast';

const TaskView = () => {
  const { id } = useParams();
  const [task, setTask] = useState();
  const toast = useToast();

  useEffect(() => {
    const fetchTask = async () => {
      try {
        const res = await fetchOrder(id);
        setTask(res);
      } catch (e) {
        console.error('Error in TaskView:', e);
        toast.error('Tilauksen haku epäonnistui');
      }
    };

    fetchTask();
  }, [id]);

  return (
    <Container>
      <BackLink to="/tilauslista">Takaisin</BackLink>
      <h2>Tilaus</h2>
      {task && <TaskListAccordion task={task} alwaysOpen />}
    </Container>
  );
};

const Container = styled.div``;

const BackLink = styled(Link)`
  display: block;
  margin-bottom: 16px;
`;

export default TaskView;
